import React from "react";
import PropTypes from "prop-types";
import uuid from "uuid/v4";
import EmptyStateMessage from "../elements/empty-state-message";
import Loading from "../elements/loading";
import useInfiniteScroll from "../../hooks/use-infinite-scroll";

// To not use infinite scrolling don't pass in a fetchMore function
const ResponsiveFlexTable = ({
  emptyStateMessageText = "Not available",
  total,
  limit,
  fetchMore,
  loading,
  ...props
}) => {
  const list_ref = React.useRef(null);
  useInfiniteScroll(fetchMore, list_ref.current);

  return (
    <div className="et--responsive-flex-table">
      {props.data.length ? (
        <div className="et--responsive-flex-table--container" ref={list_ref}>
          {loading && <Loading text="Loading" />}
          {props.data.map(datum => {
            return (
              <div className="et--responsive-flex-table--item" key={uuid()}>
                {props.columns.map(
                  ({ Cell, ...col }) =>
                    Cell ? (
                      <Cell key={uuid()} {...datum} />
                    ) : (
                      <div className="et--responsive-flex-table--row" key={uuid()}>
                        <div className="et--responsive-flex-table--row-content">
                          <span>{col.header}</span>
                          {typeof col.accessor === "function" ? col.accessor(datum) : datum[col.accessor]}
                        </div>
                      </div>
                    )
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <EmptyStateMessage text={emptyStateMessageText} />
      )}
    </div>
  );
};

ResponsiveFlexTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  emptyStateMessageText: PropTypes.string,
  total: PropTypes.number,
  limit: PropTypes.number,
  fetchMore: PropTypes.func,
};

export default ResponsiveFlexTable;
